"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function areEventContextsEqual(eventA, eventB) {
    var contextA = eventA.context;
    var contextB = eventB.context;
    return (contextA.accountId === contextB.accountId &&
        contextA.projectId === contextB.projectId &&
        contextA.clientName === contextB.clientName &&
        contextA.clientVersion === contextB.clientVersion &&
        contextA.revision === contextB.revision &&
        contextA.anonymizeIP === contextB.anonymizeIP &&
        contextA.botFiltering === contextB.botFiltering);
}
exports.areEventContextsEqual = areEventContextsEqual;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@optimizely/js-sdk-event-processor/lib/events.js
// module id = 1346
// module chunks = 11